"use client";
import { Heading, ProductCard } from "@/components/atoms";
import Page from "@/components/atoms/Page";
import ProductGrid from "@/components/molecules/ProductGrid";

import { useQuery } from "@tanstack/react-query";

import { recommendations } from "@/app/products/[...category]/serverUtils/depict";
import {
  DepictDisplay,
  formatDepictDisplayToPC,
} from "@/app/products/[...category]/serverUtils/getInitialPlpData";
import { getDepictMarketFromPricelistId } from "@/app/products/[...category]/serverUtils/helpers";
import { DepictOptions } from "@/lib/depict/types";
import { getUserData } from "@/lib/global/actions";

import { ProductCard as PC } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import styles from "../RelatedProducts/related-products.module.css";

export const RecentlyViewed = ({
  productIds,
  currentProductId,
}: {
  productIds: (string | undefined)[];
  currentProductId: string;
}) => {
  const { data: recentlyViewedProducts } = useQuery({
    queryKey: ["recently-viewed", productIds],
    queryFn: async () => {
      const userData = await getUserData();

      const options: DepictOptions = {
        locale: "en",
        session_id: userData?.token,
        product_ids: productIds.filter((id): id is string =>
          Boolean(id && id !== currentProductId)
        ),
        type: "recently_viewed",
        limit: 4,
        market: getDepictMarketFromPricelistId(userData?.pricelist) || "us",
      };

      const result = await recommendations("camillapihl", options);

      if (!result.ok) {
        console.error("Depict recommendation error", result.err);
        throw new Error("Failed to fetch related products");
      }

      return (result.val.displays as unknown as DepictDisplay[])
        .map((display) => formatDepictDisplayToPC(display))
        .filter(Boolean) as PC[];
    },
  });

  if (!recentlyViewedProducts || recentlyViewedProducts.length === 0)
    return null;
  return (
    <div className={styles.background}>
      <Page as="section">
        <div className={styles.title}>
          <Heading as={"h2"} styledAs="t2">
            {"Recently Viewed"}
          </Heading>
        </div>
        <ProductGrid>
          {recentlyViewedProducts
            .filter((p) => p.depictProductId !== currentProductId)
            .map((product, i) => (
              <ProductCard
                className="product-card"
                product={product!}
                key={i}
              />
            ))}
        </ProductGrid>
      </Page>
    </div>
  );
};
